import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($scope, claimViewModel) {
    var ctrl = Object.create(BaseCtrl);

    ctrl.init = function () {
        $scope.claimVm = claimViewModel();
        $scope.claimVm.lobs.homeowners.propertyFireDamage.value = $scope.claimVm.lobs.homeowners.propertyFireDamage.value || {
            isHomeHabitable: true,
            isHomeSecure: true
        };
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'claimViewModel'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/ho/controllers/HOFireDetailsCtrl.js
// module id = 1551
// module chunks = 0